module.exports = __webpack_public_path__ + "img/OpenFBA-Sticker-Dark.deef2443.svg";